import apiFetch from '../apiFetch'

export default function (documentTypeUse, fromManual, token) {
  return apiFetch({ endPoint: `document/${documentTypeUse}?fromManual=${fromManual}`, method: 'GET', token: token })
}
